<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
</style>
<template>
  <div class="l-edit-dialog-box" style="padding-top:15px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="社区责任人管理" name="first">
        <div style="margin-bottom: 8px;">
          <l-auth-button type="primary" auth="department_info_add_btn" @click="showAdd()"> 添加 </l-auth-button>
        </div>

        <l-table :data="form_data" v-loading="loading" row-key="id" style=" max-height: 30vh;">
          <el-table-column fixed prop="index" label="序号" min-width="200"> </el-table-column>
          <el-table-column fixed prop="type_name" label="场所类型" min-width="200"> </el-table-column>
          <el-table-column prop="state" label="隐患等级" min-width="200"></el-table-column>
          <el-table-column prop="user_name" label="责任人" min-width="200"> </el-table-column>
          <el-table-column prop="user_iphone" label="电话" min-width="200"> </el-table-column>
          <el-table-column prop="created_at" label="添加时间" width="120"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="150" align="center">
            <template slot-scope="{ row }">
              <l-auth-text-button type="primary" auth="department_info_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>修改</l-auth-text-button>
              <span class="l-action-separator">|</span>
              <l-auth-text-button type="danger" auth="department_info_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
            </template>
          </el-table-column>
        </l-table>
      </el-tab-pane>
    </el-tabs>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
    </div>

    <!--修改-->
    <l-dialog :visible.sync="edit_visible" title="修改" width="1000px">
      <l-department-info-edit @on-success="onAddSucess" :visible.sync="edit_visible" :id="edit_id"></l-department-info-edit>
    </l-dialog>
    <!--添加-->
    <l-dialog :visible.sync="save_visible" title="添加" width="1000px">
      <l-department-info-edit @on-success="onAddSucess" :visible.sync="save_visible" :community_id="community_id"></l-department-info-edit>
    </l-dialog>
  </div>

</template>

<script>
import InfoSave from "./InfoSave.vue";
import Vue from "vue";
export default {
  name: 'l-department-info',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
    [InfoSave.name]: InfoSave,
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      activeName: 'first',
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,//页面是否加载中
      //表单数据
      edit_id: 0,
      edit_visible: false,
      save_visible: false,
      form_data: [],
      community_id: 0,
    }
  },
  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    handleClick() {
    },
    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //显示添加界面
    showAdd() {
      this.$nextTick(() => {
        this.save_visible = true;
      });
    },

    //添加成功回调
    onAddSucess() {
      this.save_visible = false;
       this.edit_visible = false;
      this.getData();
    },
    //编辑成功回调
    // onEditSucess() {
    //   this.edit_visible = false;
    //   this.getData();
    // },
    //获取数据
    getData() {
      if (this.hasId) {
        this.community_id = this.$props.id;
        // console.log(this.$props.id)
        this.loading = true;
        this.$_invoke(`cabinetTemplate_getMaterialList`, { community_id: this.$props.id ,
         page: this.page,
        page_size: this.page_size,
        }).then((ret) => {
          this.form_data = ret.data
        }).finally(() => {
          this.loading = false;
        });

      }
    },
    // inspectInfo() {
    //   // // console.log(row);
    // },
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`communityDuty_del`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getData();
          });
        })
        .catch(() => { });
    },

  },
}
</script>